import { Field, Form } from "react-final-form";
import React, { Component } from "react";

import Button from "Components/Button";
import { FormError } from "Themes/StyledComponents";
import FormInput from "Components/FormInput/FormInput";
import LoadingIcon from "Components/LoadingIcon";
import styled from "styled-components";

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
`;

// const ForgottenPasswordContainer = styled.div`
//   color: blue;
//   cursor: pointer;
//   text-align: left;
//   margin-top: 10px;
//   &:hover {
//     text-decoration: underline;
//   }
// `;

const validate = (values) => {
  const errors = {};
  if (!values.username) {
    errors.username = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  return errors;
};

class LoginForm extends Component {
  render() {
    const {
      handleSubmit,
      // forgottenPassword,
      loginError,
      navigateToSignup,
      fetching,
    } = this.props;
    return (
      <Form
        validate={validate}
        onSubmit={handleSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name={"username"}
              render={(props) => <FormInput {...props} placeholder={"Username"} />}
            />
            <Field
              name={"password"}
              type={"password"}
              placeholder={"Password"}
              render={(props) => <FormInput type={"password"} {...props} />}
            />
            {loginError ? <FormError>{loginError}</FormError> : null}
            <ButtonContainer>
              <Button type={"submit"} style={{ marginRight: 10, flex: 1 }}>
                {fetching ? <LoadingIcon /> : "Login"}
              </Button>
              {navigateToSignup && (
                <Button
                  type={"button"}
                  onClick={navigateToSignup}
                  style={{ marginLeft: 10, flex: 2 }}
                >
                  You're new? Signup here
                </Button>
              )}
            </ButtonContainer>
            {/* <ForgottenPasswordContainer onClick={forgottenPassword}>
              Forgotten password?
            </ForgottenPasswordContainer> */}
          </form>
        )}
      />
    );
  }
}

export default LoginForm;
